import {Component, Input, OnChanges, OnInit} from '@angular/core'
import {FormArray, FormControl, FormGroup, FormGroupDirective} from '@angular/forms'

@Component({
  selector: 'dmmp-form-events',
  templateUrl: './events.component.html',
})
export class EventsComponent implements OnInit, OnChanges {
  @Input() field
  @Input() identifier
  @Input() form: FormGroup
  @Input() dateFilter
  @Input() subEventsInput
  @Input() invalidEvents
  dateAct = Math.round(new Date().getTime() / 1000)
  formParent
  @Input() textInfo = ' Elige las actividades a las que quieres asistir'

  constructor(private parent: FormGroupDirective) {
    this.formParent = parent.form
  }

  ngOnInit() {
  }

  ngOnChanges() {
  }

  onCheckboxChange(e, SubEvent) {
    const checkArray: FormArray = this.form.get('checkSubEvent') as FormArray
    if (e.target.checked) {
      checkArray.push(new FormControl(SubEvent))
      this.formParent.setControl('events', checkArray)
    } else {
      checkArray.controls.forEach((item: FormControl, index) => {
        if (item.value === SubEvent) {
          checkArray.removeAt(index)
          return
        }
      })
    }
  }
}
